import paymentConstants from "../constants/paymentConstants";

export const createPayment = (payload: any) => ({
  type: paymentConstants.CREATE_PAYMENT_REQUEST,
  payload,
});

export const retrievePayments = (payload: any) => ({
  type: paymentConstants.GET_PAYMENTS_REQUEST,
  payload,
});

export const retrievePaymentDetails = (payload: any) => ({
  type: paymentConstants.GET_PAYMENT_DETAILS_REQUEST,
  payload,
});

export const updatePayment = (payload: any) => ({
  type: paymentConstants.UPDATE_PAYMENT_REQUEST,
  payload,
});

export const resetPayments = () => ({
  type: paymentConstants.RESET_PAYMENTS,
});
